"use client";

import { useMemo } from "react";
import { usePathname } from "next/navigation";

/**
 * Current pathname split into non-empty URL segments (no leading slash).
 */
export function usePathnameSegments() {
  const pathname = usePathname();
  const segments = useMemo(
    () => pathname.split("/").filter(Boolean),
    [pathname],
  );
  return { pathname, segments };
}
